 <my-header></my-header>
    
<div class="container process-payment-scroll">
   <app-banner></app-banner>
    <div class="page">
    <h2 class="page-title">Process Payment</h2>
    <div class="grid">
      <div class="left">
        <app-signature-capture [zeroCopay]="zeroCopay"  (isSignatureApplyied)="onSignature($event)" [selectedTransDetails]="selectedTransDetails"></app-signature-capture>
      </div>
      <div *ngIf="!zeroCopay" class="right header-payment">
        <div>Payment Method</div>
        <div class="cards-block">
          <div class="cards-label">Cards</div>
          <label *ngIf="CardsDetails?.length" class="card-row">
            <input type="radio" name="savedCard" [checked]="true" class="card-radio" />
            <span><img class="pm-selected" src="/assets/images/card.svg" alt="Selected" /></span>
            <div class="card-meta">
              <div class="line-1">**** **** **** {{ selectedCardId?.last4 }}</div>
              <div class="line-2 muted">
                {{ selectedCardId?.cardType || 'Card' }} |
                Expires {{ selectedCardId?.expiryDate | date:'MM/yy' }}
              </div>
            </div>
          </label>
          <button type="button" class="change-button"  *ngIf="CardsDetails?.length" [disabled]="!hasSignature" (click)="openPaymentMethodsPopup()">
            Change Payment Method
          </button>
          <button class="add-card" *ngIf="!CardsDetails?.length" type="button" [disabled]="!hasSignature" (click)="onAddCard()">
          <img src="/assets/images/add card.svg" alt="addcard" />Add card </button>
          <div class="total-row">
            <div>Total:</div>
            <div class="amount">{{ selectedTransDetails?.amount | currency:'USD':'symbol':'1.2-2' }}</div>
          </div>
        </div>
        <div class="actions">
          <button class="btn cancel" type="button" (click)="cancel()">Cancel</button>
          <button class="btn primary pay-now-btn" type="button" [disabled]="!(hasSignature && !!CardsDetails?.length)" (click)="processPayment()">Pay Now</button>
        </div>
      </div>
    </div>
  </div>
  <div
  *ngIf="openPaymentMethods"
  class="pm-overlay"
  (click)="$event.stopPropagation()" 
  aria-hidden="false"
>
<div class="modal-overlay">
  <div
    class="pm-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="pm-title"
    (click)="$event.stopPropagation()"
    (keydown.escape)="closePaymentMethodsPopup()"
    tabindex="0"
  >
    <div class="pm-header">
   <span>Payment Methods</span>
      <button class="pm-x" type="button" (click)="closePaymentMethodsPopup()" aria-label="Close">✕</button>
    </div>

    <div class="pm-sub">
      <span>Choose from your saved payment methods or add a new card.</span>
    </div>

    <div class="pm-legend">
       <button class="pm-link" type="button" (click)="onAddCard()">+ Add card</button>
    </div>

    <div class="pm-list">
      <label class="pm-item"  [ngClass]="{ 'selected-card': selectedCardId?.token === c?.token }" *ngFor="let c of CardsDetails; let i = index" (click)="selectCard(c)">
        <div class="pm-left">
          <input
            class="pm-radio"
            type="radio"
            name="pm"
            [checked]="selectedCardId?.token === c?.token"
            (change)="selectCard(c)"
          />
          <span><img class="pm-selected" src="/assets/images/card.svg" alt="Selected" /></span>
          <div class="pm-meta">
              <div class="pm-alias" *ngIf="c?.cardAlias">{{ c.cardAlias }}</div>
            <div class="pm-line1">
              **** **** **** {{ c?.last4 }}
            </div>
            <div class="pm-line2">
              {{ c?.cardType || 'Card' }} | Expires {{ toMMYY(c?.expiryDate) }}
            </div>
          </div>
        </div>

        <div class="pm-right">
          <div class="pm-pills">
            <button class="pm-pill" type="button" (click)="openRemovePopup(c)">Remove</button>
            <button class="pm-pill" type="button" (click)="openEdit(c)">Edit</button>
          </div>
        </div>
      </label>
    </div>

    <div class="pm-actions">
      <button class="btn cancel" type="button" (click)="closePaymentMethodsPopup()">Cancel</button>
      <button class="btn primary" type="button" (click)="confirmSelection()">Continue</button>
    </div>
  </div>
  </div>
</div>

<div *ngIf="showWorldpay" class="world_pay-overlay"  (click)="$event.stopPropagation()" >
  <div class="worldpay-modal worldpay-modal--lg" (click)="$event.stopPropagation()">
    <div class="pm-header">
      <h3>Add a new card</h3>
      <button class="pm-x" type="button" (click)="closeWorldpay()" aria-label="Close">✕</button>
    </div>

    <div class="wp-frame-wrap">
      <div *ngIf="wpLoading" class="wp-loading">Loading…</div>
      <iframe
        *ngIf="showWorldpay && worldpayUrl"
        class="wp-frame"
        [src]="worldpayUrl"
        (load)="wpLoading=false"
      ></iframe>
    </div>

    <!-- <div class="pm-actions">
      <button class="btn cancel" type="button" (click)="closeWorldpay()">Cancel</button>
    </div> -->
  </div>
</div>

<div class="edit-overlay" *ngIf="showEdit" (click)="$event.stopPropagation()">
<div class="edit-modal" >
  <div class="edit-header">
    <span>Edit Payment Method</span>
    <button class="pm-x" type="button" (click)="closeEdit()" aria-label="Close">✕</button>
  </div>

  <!-- Card line (brand + last4) -->
  <div class="card-line">
    <span><img class="pm-selected card_top" src="/assets/images/card.svg" alt="Selected" /></span>
    <span class="card-text">
      {{ currentCard?.brand || 'Card' }} **** {{ currentCard?.last4 }}
    </span>
  </div>

  <!-- FORM START -->
  <form [formGroup]="editFG" (ngSubmit)="updateCard()">
    <!-- Nickname -->
    <div class="custom-input-container">
      <label>Card Nickname</label>
      <input type="text" formControlName="nickname" placeholder="Card Name" />
    </div>

    <!-- Expiry dropdowns -->
<!-- Expiry dropdowns -->
<div class="edit-card">
  <div class="editcard_body">

    <!-- Exp Month -->
<div class="dropdown-container" [formGroup]="editFG">
  <label class="dropdown-label">Exp Month</label>
  <div class="dropdown-control"
       (click)="toggleDropdown('month')">
    {{ editFG.get('month')?.value || 'Select Month' }}
  </div>
  <ul *ngIf="showMonthDropdown" class="dropdown-list month-dropdown">
    <li *ngFor="let m of months"
        (click)="editFG.get('month')?.setValue(m); closeAllDropdowns()">
      {{ m }}
    </li>
  </ul>
</div>

<!-- Exp Year -->
<div class="dropdown-container" [formGroup]="editFG">
  <label class="dropdown-label">Exp Year</label>
  <div class="dropdown-control"
       (click)="toggleDropdown('year')">
    {{ editFG.get('year')?.value || 'Select Year' }}
  </div>
  <ul *ngIf="showYearDropdown" class="dropdown-list year-dropdown">
    <li *ngFor="let y of years"
        (click)="editFG.get('year')?.setValue(y); closeAllDropdowns()">
      {{ y }}
    </li>
  </ul>
</div>
<div *ngIf="showMonthDropdown || showYearDropdown"
     class="dropdown-backdrop"
     (click)="closeAllDropdowns()"></div>
  </div>
</div>



    <div class="pm-actions">
      <button class="btn cancel" type="button" (click)="closeEdit()">Close</button>
      <button class="btn primary" type="submit">Save</button>
    </div>
  </form>
</div>
</div>

<div class="popup-overlay" *ngIf="showRemovePopup">
  <div class="popup">
    <div class="pm-header">
      <span>Remove card?</span>
    <button class="pm-x" type="button" (click)="closeRemovePopup()" aria-label="Close">✕</button>
    
  </div>
  <div class="display_flex">
    <span><img class="pm-selected" src="/assets/images/card.svg" alt="Selected" /></span>
    <div class="pm-meta card-display_left">
      <div class="pm-line1">
        **** **** **** {{ selectedCard?.last4 }}
        <span class="pm-chip" *ngIf="selectedCard?.preferences === 'DEFAULT' || selectedCard?.preferences === true">
          Shopping Card
        </span>
      </div>
      <div class="pm-line2">
        {{ selectedCard?.cardType || 'Card' }} | Expires {{ toMMYY(selectedCard?.expiryDate) }}
      </div>
    </div>
    </div>
    <div class="popup-actions">
      <button class="btn cancel" (click)="closeRemovePopup()">Cancel</button>
      <button class="btn primary" (click)="removeCard(selectedCard)">Remove</button>
    </div>
  </div>
</div>
<app-error-popup
  [show]="showErrorPopup"
  [errorMessage]="errorMessage"
  (close)="onCloseErrorPopup()">
</app-error-popup>
</div>

